import { ZIM } from 'zego-zim-web'; // Hanya mengimpor ZIM

const appID = 1707882354; // Gantilah dengan cara Anda mendapatkan appID
const serverSecret = '3a465d4d268f99089979bcc6ff58ef34'; // Gantilah dengan cara Anda mendapatkan appID

// Fungsi untuk membuat atau mendapatkan instance ZIM
const createZIMInstance = (): any | null => { // Ganti ZIMInstance dengan any
    if (!ZIM.getInstance()) {
        ZIM.create({ appID });
    }
    return ZIM.getInstance();
};

export const zim = createZIMInstance();
